
<template>
  <div style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row style="border:0px solid green;position: inherit;display:contents;width:100%;">
        <div class="box box-success" v-if="false">
          <div class="box-header with-border">
            <h3 class="box-title">{{$t('search.title')}}</h3>
          </div>

          <div class="box-body">
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-4 col-md-4 col-lg-4">
                <input
                  type="text"
                  v-on:keyup.enter="onSearchInvoiceGeneralInvoice"
                  class="form-control"
                  :placeholder="$t('apartment.reservations.address')"
                  v-model="search.address"
                />
              </div>
              <div class="col-sm-4 col-md-4 col-lg-4">
                <input
                  v-on:keyup.enter="onSearchInvoiceGeneralInvoice"
                  type="text"
                  class="form-control"
                  :placeholder="$t('apartment.reservations.code')"
                  v-model="search.code"
                />
              </div>
              <div class="col-sm-4 col-md-4 col-lg-4">
                <input
                  v-on:keyup.enter="onSearchInvoiceGeneralInvoice"
                  type="text"
                  class="form-control"
                  :placeholder="$t('apartment.reservations.customer')"
                  v-model="search.customer"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <button
                  type="button"
                  class="btn btn-texted btn-success pull-right"
                  @click="onSearchInvoiceGeneralInvoice"
                >
                  <span class="btn-text">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{$t('search.search_button')}}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="box box-primary" style="width:100%">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <b>{{$t('invoice_general_invoice.title')}}</b>
              <lte-button
                style="float:right;background-color:white !important;"
                type="btn btn-default"
                right_icon="fa fa-plus"
                @click="callback($event)"
              >{{$t('common.add')}}</lte-button>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-sm-12 table-responsive no-padding">
                  <lte-table-invoice-general-invoice
                    :hdBackground="hdBackground"
                    :data="invoiceGeneralInvoiceList"
                    :columns="invoiceGeneralInvoiceFields"
                    search_filter="left-search"
                    @actions="crudActions"
                    :useFilter="useFilter"
                    :actions="actions"
                    @onClickItemRow="onClickItemRow"
                    :row_mouse_pointer="true"
                    :boxStyle="boxStyle"
                  >></lte-table-invoice-general-invoice>
                </div>
              </div>
            </div>
          </div>
        </div>

        <lte-modal-invoice-general-invoice-detail
          ref="modalInvoiceGeneralInvoiceDetail"
          @callbackInvoiceGeneralInvoiceSuccess="onRefreshInvoiceGeneralInvoiceList"
        ></lte-modal-invoice-general-invoice-detail>

        <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
        <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading>

        <lte-modal
          v-show="isModalVisible"
          @onConfirm="onConfirm"
          @close="closeModal"
          v-for="obj in objModal"
          :key="obj.id"
          :item="obj"
        ></lte-modal>

        <div class="box-footer clearfix" style="display:contents;">
          <paginator :item="paginatorItem" @onpaginate="onPagination" />
        </div>
      </row>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";
import utils from '@/lib/utils';
import i18n from "../../lang";
import LTEButton from "@/components/LTEButton.vue";

import { LTEActionTypeEnum } from '@/components/LTEEnum'
import LTETableInvoiceGeneralInvoice from "@/components/LTETableInvoiceGeneralInvoice.vue";
// import LTECoreAlert from "@/components/LTESnackBar.vue";
import Paginator from "@/components/Paginator.vue";

import LTEModalInvoiceGeneralInvoiceDetail from "@/components/LTEModalInvoiceGeneralInvoiceDetail";
import LTEModal from "@/components/LTEModal.vue";

export default {
  name: "InvoiceGeneralInvoiceList",
  data() {
    return {
      invoiceGeneralInvoiceList: [],
      invoiceGeneralInvoiceFields: [
        { text: "common.nonumber", isHidden: true },
        {
          key: "code",
          text: "invoice_general_invoice.code",
          sortable: true,
          class: "text-center",
          isHidden: true
        },
        {
          key: "customer",
          text: "invoice_general_invoice.customer",
          sortable: true,
          class: "text-center",
          isHidden: true
        },
        {
          key: "address",
          text: "invoice_general_invoice.address",
          sortable: true,
          class: "text-center",
          isHidden: true
        },
        {
          key: "description",
          text: "invoice_general_invoice.description",
          sortable: true,
          class: "text-center",
          isHidden: true
        },
        {
          key: "amount",
          text: "invoice_general_invoice.amount",
          sortable: true,
          class: "text-center",
          isHidden: true
        },
        {
          key: "type_name",
          text: "invoice_general_invoice.type_name",
          sortable: true,
          class: "text-center",
          isHidden: true
        },
        {
          key: "purpose_name",
          text: "invoice_general_invoice.purpose_name",
          sortable: true,
          class: "text-center",
          isHidden: true
        },
        {
          key: "correlation_key",
          text: "invoice_general_invoice.correlation_key",
          sortable: true,
          class: "text-center",
          isHidden: true
        },
        // {
        //   key: "user_created_full_name",
        //   text: "invoice_general_invoice.user_created_full_name",
        //   sortable: true,
        //   class: "text-center",
        //   isHidden: true
        // },
        { key: "actions", text: "common.action", class: "text-center" }
      ],

      hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;", //00a65a
      boxStyle: false,
      useFilter: false,
      actions: ["common.delete", "common.printPdf"],
      paginatorItem: {
        commit_function: "GET_INVOICE_GENERAL_INVOICE_LIST"
      },
      originalRecordData: [],
      isModalVisible: false,
      objModal: [
        {
          title    : "common.delete_modal.title",
          body     : "common.delete_modal.content",
          buttonNo : "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ],

      isLoading: false,

      invoice_general_invoice_list: [],
      search: {
        code: "",
        address: "",
        customer: ""
      },
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false
      }
    };
  },
  watch: {
    GET_LANG: function() {
      this.invoice_general_invoice_list[i].user_created_full_name;
    },
    GET_INVOICE_GENERAL_INVOICE_DATA: function() {
      this.isLoading = false;
      this.invoice_general_invoice_list = this.GET_INVOICE_GENERAL_INVOICE_DATA;
      this.invoiceGeneralInvoiceList = [];
      for (
        let i = 0, size = this.invoice_general_invoice_list.length;
        i < size;
        i++
      ) {
        let nonumber =
          i + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size;
        let type_name = this.$t(
          "payments.payments_type[" +
            (this.invoice_general_invoice_list[i].type - 1) +
            "]"
        );

        let purpose_name = this.$t(
          "invoice_purpose." + this.invoice_general_invoice_list[i].purpose_name
        );

        let object = {
          "common.nonumber": nonumber,
          id: this.invoice_general_invoice_list[i].id,
          "invoice_general_invoice.code": this.invoice_general_invoice_list[i]
            .code,
          "invoice_general_invoice.customer": this.invoice_general_invoice_list[
            i
          ].customer,
          "invoice_general_invoice.address": this.invoice_general_invoice_list[
            i
          ].address,
          "invoice_general_invoice.description": this
            .invoice_general_invoice_list[i].description,
          "invoice_general_invoice.amount": utils.formatNumber(
            utils.makeRoundNumber(this.invoice_general_invoice_list[i].amount)
          ),
          "invoice_general_invoice.type_name": type_name,
          "invoice_general_invoice.purpose_name": purpose_name,
          "invoice_general_invoice.correlation_key": this
            .invoice_general_invoice_list[i].correlation_key,
          "invoice_general_invoice.user_created_full_name": utils.getFullName(
            this.invoice_general_invoice_list[i].user_created_first_name,
            this.invoice_general_invoice_list[i].user_created_last_name,
            i18n.locale
          ),
          "type": this.invoice_general_invoice_list[i].type
        };
        this.invoiceGeneralInvoiceList.push(object);
      }
    }
  },
  computed: {
    ...mapGetters([
      "GET_INVOICE_GENERAL_INVOICE_DATA",
      "GET_LANG",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_SNACK_BAR"
    ])
  },
  methods: {
    ...mapActions([
      "GET_INVOICE_GENERAL_INVOICE_LIST",
      "ERROR_TOAST",
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "DELETE_INVOICE_GENERAL_INVOICE"
    ]),
    callback: function() {
      this.$refs.modalInvoiceGeneralInvoiceDetail.setCallBackFrom(
        "INVOICE_GENERAL_INVOICE"
      );
      this.$refs.modalInvoiceGeneralInvoiceDetail.submit(0);
    },
    crudActions: function(recordData, actionsType, isModalVisible) {
      if (actionsType == LTEActionTypeEnum.MODIFY) {
        this.$refs.modalInvoiceGeneralInvoiceDetail.submit(recordData.id);
      } else if (actionsType == LTEActionTypeEnum.PRINT) {
        let name = "InvoiceGeneralInvoicePdf_TM";
        if (recordData.type != 1) name = "InvoiceGeneralInvoicePdf_CK";

        let routeData = this.$router.resolve({
          name: name,
          params: {
            id: recordData.id
          }
        });
        window.open(routeData.href, "_blank");
      } else {
        this.originalRecordData = recordData;
        this.isModalVisible = isModalVisible;
      }
    },
    onClickItemRow: function(entryId) {
      this.$refs.modalInvoiceGeneralInvoiceDetail.submit(entryId);

      // this.entryId = entryId;
      // $("#modal-information-user").modal("show");
    },
    onPrevPagination: function() {
      const data = {
        url: this.PAGE_ARROW.prev,
        commit_funtion: "GET_INVOICE_GENERAL_INVOICE_LIST"
      };
      this.PAGINATION_PREV_PAGE(data);
    },
    onNextPagination: function() {
      const data = {
        url: this.PAGE_ARROW.next,
        commit_funtion: "GET_INVOICE_GENERAL_INVOICE_LIST"
      };
      this.PAGINATION_NEXT_PAGE(data);
    },
    onPagination: function(data) {
      this.GET_INVOICE_GENERAL_INVOICE_LIST(data);
    },

    onSearchInvoiceGeneralInvoice: function() {
    },
    onRefreshInvoiceGeneralInvoiceList: function() {
      const data = {
        params: {
          page: 1
        }
      };
      this.isLoading = true;
      this.GET_INVOICE_GENERAL_INVOICE_LIST(data)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    showModalRow: function(item) {
      this.$refs.modalBookingDetail.submit(item.item.id);
    },
    onConfirm: function() {
      this.isModalVisible = false;
      this.DELETE_INVOICE_GENERAL_INVOICE(this.originalRecordData)
        .then(
          function() {
            const data = {
              params: {
                page: 1
              }
            };
            this.GET_INVOICE_GENERAL_INVOICE_LIST(data);
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    closeModal() {
      this.isModalVisible = false;
    }
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    "lte-table-invoice-general-invoice": LTETableInvoiceGeneralInvoice,
    loading: Loading,
    paginator: Paginator,
    "lte-modal-invoice-general-invoice-detail": LTEModalInvoiceGeneralInvoiceDetail,
    "lte-button": LTEButton,
    "lte-modal": LTEModal
  },
  mounted() {
    const data = {
      params: {
        page: 1
      }
    };
    this.GET_INVOICE_GENERAL_INVOICE_LIST(data);
  }
};
</script>

<style scoped>
.mg-left {
  margin-left: 5px;
}
.hide-scroll-bar::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Apartment/InvoiceGeneralInvoiceList.vue